export default "__VITE_ASSET__77d849bc__"